import DataGrid, {
    Column,
    Pager,
    Paging,
    Lookup,
} from 'devextreme-react/data-grid';

import DataSource from 'devextreme/data/data_source';
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { backendlink } from '../../config';
import './PartnerPatientLogDatagrid.css';

export default function PartnerPatientLogDatagrid() {

    const { user } = useAuth();

    const navigate = useNavigate();

    const [patientToken, setPatientToken] = useState("")

    const location = useLocation();

    const [linkedCustomerName, setLinkedCustomerName] = useState('');
    const [linkedCustomerID, setLinkedCustomerID] = useState('');
    const [linkedDoctorName, setLinkedDoctorName] = useState('');
    const [patientName, setPatientName] = useState('');

    const initalPageSize = 5;
    const initalPageIndex = 0;

    const fetchData = async () => {
        try {
            const response = await axios.post(backendlink + 'partner/getpatient',
            {
                usertoken: user.userToken,
                patienttoken: location.state.patientToken
            },
            {
                headers: {
                    token: user.token
                }
            });

            if (response.data.errorno == 0) {
                const outputArray = response.data.result.map(item => {
                    setLinkedCustomerName(item.linkedcustomer)
                    setLinkedCustomerID(item.linkedcustomerid)
                    setLinkedDoctorName(item.linkeddoctor)
                    setPatientName(item.name)

                    fetchLog({ skip: initalPageIndex, take: initalPageSize })
                });
            } else {
                alert(response.data.errmessage);
            }
        } catch (error) {
            alert(error);
        }
    };

    const fetchLog = async (loadOptions) => {
        try {
            const page = Math.floor(loadOptions.skip / loadOptions.take) + 1;
            const size = loadOptions.take;

            let sortStr = "logTimestamp:desc";//default sort by recordTime desc
            if(loadOptions.sort){
                sortStr = loadOptions.sort[0].selector;
                if (loadOptions.sort[0].desc) {
                    sortStr += ":desc";
                }else{
                    sortStr += ":asc";
                }
            }

            let postData = {
                userToken: user.userToken,
                patientToken: location.state.patientToken,
                page: page,
                size: size,
                sorts:sortStr,
            };

            const response = await axios.post(backendlink + 'partner/getpatientlogs',
                postData,
                {headers: {token: user.token}}
            );

            if (response.data.errorno == 0) {
                return {
                    data: response.data.result, // Data for the current page
                    totalCount: response.data.meta.total, // Total number of records
                };
                //setLogs()
            } else {
                alert(response.data.errmessage);
            }
        } catch (error) {
            alert(error);
        }
    };

    const [dataSource] = useState(new DataSource({
        load: fetchLog,
    }));

    useEffect(() => {
        if (location.state?.patientToken == null) {
            navigate('/');
        } else {
            setPatientToken(location.state.patientToken);
            fetchData();
        }
    }, [user]);

    return (
        <React.Fragment>
            <table className="custom-table">
                <thead>
                    <tr>
                        <th>Organization:</th>
                        <td>{linkedCustomerName}</td>
                        <th>Organization ID:</th>
                        <td>{linkedCustomerID}</td>
                        <th>Doctor:</th>
                        <td>{linkedDoctorName}</td>
                        <th>Patient:</th>
                        <td>{patientName}</td>
                    </tr>
                </thead>
            </table>

            <DataGrid 
                dataSource={dataSource}
                cacheEnabled={false}
                remoteOperations={true}
            >
                <Column dataField='logTimestamp' caption='Date' />
                <Column dataField='activity' caption='Activity' />
                <Column dataField='logDescription' caption='Details' />
                <Pager allowedPageSizes={[5, 10, 20]} showPageSizeSelector={true} />
                <Paging
                    defaultPageSize={initalPageSize}
                    defaultPageIndex={initalPageIndex}
                />
                {/*<FilterRow visible={true} />*/}
                <Lookup />
                {/* <Export enabled={true} /> */}
                {/* <HeaderFilter visible={true} /> */}
            </DataGrid>
        </React.Fragment>
    )
}